export const UI_LABELS = {
  ACCESS_CREDENTIAL: "Access Credential",
  ACCESS_CREDENTIALS: "Access Credentials",
  QR_CODE_VISITOR_PASS: "QR Code Visitor Pass",
  PIN_CODE_VISITOR_PASS: "PIN Code Visitor Pass",
  VISITOR_PASS: "Visitor Pass",
  VISITOR_PASSES: "Visitor Passes",
  BLUETOOTH_ACCESS: "Bluetooth Access",
  TEMPORARY_VISITOR_PASS: "Temporary Visitor Pass",
  FULL_DAY_VISITOR_PASS: "Full Day Visitor Pass",
  FULL_DAY_VISITOR_PASSES: "Full Day Visitor Passes",
  BUSINESS_HOUR_VISITOR_PASS: "Business Hour Visitor Pass",
   VISITOR_PASS_TEMPLATES: "Visitor Pass Templates",
   RESTRICTION_PASS_TEMPLATE: "Recurring Template",
   DURATION_PASS_TEMPLATE: "Single-Use / Temporary Template",
  TEMPORARY_VISITOR_PASSES: "Temporary Visitor Passes",
  RECURRING_VISITOR_PASS: "Recurring Visitor Pass",
  RECURRING_VISITOR_PASSES: "Recurring Visitor Passes",
  SINGLE_USE_VISITOR_PASS: "Single-Use Visitor Pass",
  QR_TEMPORARY_VISITOR_PASS: "QR Temporary Visitor Pass",
  QR_RECURRING_VISITOR_PASS: "QR Recurring Visitor Pass",
  PIN_TEMPORARY_VISITOR_PASS: "PIN Temporary Visitor Pass",
  PIN_TEMPORARY_VISITOR_PASSES: "PIN Temporary Visitor Passes",
  QR_SINGLE_USE_VISITOR_PASS: "QR Single-Use Visitor Pass",
  QR_SINGLE_USE_VISITOR_PASSES: "QR Single-Use Visitor Passes",
  PIN_SINGLE_USE_VISITOR_PASS: "PIN Single-Use Visitor Pass",
  PIN_SINGLE_USE_VISITOR_PASSES: "PIN Single-Use Visitor Passes",
  DUAL_QR_CODE: "Dual QR Code",
  DUAL_QR_CODE_FACILITY: "Dual QR Code Facility Code",
  CODE_IS_DUPLICATE_OF_PIN_TEMPORARY_VISITOR_PASS: "Code is a duplicate of a PIN Temporary Visitor Pass.",
  CODE_IS_DUPLICATE_OF_PIN_SINGLE_USE_VISITOR_PASS: "Code is a duplicate of a PIN Single-Use Visitor Pass.",
  PASS: "Pass",
  PHOTO_DOWNLOAD_AND_SHARING: "Photo Download & Sharing",
  ALLOW_CELLGATE_PHOTOS_DOWNLOAD: "Allow CellGate Photos to be Downloaded from the CellGate App?",
  ALLOW_DOWNLOADED_PHOTOS_SHARE: "Allow Downloaded Photos to be Shared from the CellGate App?",
  PHOTO_DOWNLOAD_AND_SHARING_SAVE_SUCCESS: "Photo Download & Sharing settings saved successfully!",
  PUSH_NOTIFICATIONS: "Push Notifications via CellGate App",
} as const;

export type UI_Labels = keyof typeof UI_LABELS;
